import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ClassSettingsIndexLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ClassSettingsIndex' */ './components/ClassSettingsIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<ClassSettingsIndexLazy />} />,
	};
};
